import React from "react";

import { DataWarehouseSchemasInput } from "@/apollo/types";

type ConnectFn = (
  integrationId: string,
  configuration: { [key: string]: any },
  dataWarehouseSchemas?: DataWarehouseSchemasInput,
  formId?: string,
) => Promise<void>;

export const ConnectContext = React.createContext<{
  isConnecting: boolean;
  isLoading: boolean;
  connect: ConnectFn;
}>({
  isConnecting: false,
  isLoading: false,
  connect: Promise.reject,
});

export function useConnectContext() {
  return React.useContext(ConnectContext);
}
